// https://gist.github.com/sqren/fc897c1629979e669714893df966b1b7
import { useRef } from 'react'

let uniqueId = 0
// eslint-disable-next-line no-plusplus
const getUniqueId = () => {
  uniqueId += 1
  return uniqueId.toString()
}

export default function useComponentId() {
  const idRef = useRef(getUniqueId())
  return idRef.current
}
